"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useMouseRotation2 = _interopRequireDefault(require("./useMouseRotation"));

var THREE = _interopRequireWildcard(require("three"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var addLights = function addLights(scene, color) {
  var light = new THREE.DirectionalLight(0xffffff, 0.40);
  light.position.set(-90, 400, 0);
  var hemiLight = new THREE.HemisphereLight(color, color, 0.3);
  scene.add(hemiLight);
  scene.add(light);
  return [light, hemiLight];
};

var addCone = function addCone(scene) {
  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yellow';
  var width = arguments.length > 2 ? arguments[2] : undefined;
  var height = arguments.length > 3 ? arguments[3] : undefined;
  var geometry = new THREE.ConeGeometry(width / 8, height / 5.4, 9);
  var cone = new THREE.Mesh(geometry, new THREE.MeshPhysicalMaterial({
    color: color
  }));
  cone.rotation.x += 1;
  cone.position.set(0, 5, 0);
  scene.add(cone);
  return cone;
};

var createScene = function createScene(ref, color, orbitRadius, width, height) {
  var scene = new THREE.Scene();
  var camera = new THREE.PerspectiveCamera(75, 1, 0.1, 1000);
  var renderer = new THREE.WebGLRenderer({
    antialias: true,
    alpha: true
  });
  addLights(scene, color);
  renderer.setClearColor(0xffffff, 0);
  renderer.setSize(width, height);
  scene.background = null;
  camera.position.set(0, orbitRadius, orbitRadius);
  ref.current.appendChild(renderer.domElement);

  function animate() {
    requestAnimationFrame(animate);
    renderer.render(scene, camera);
  }

  animate();
  return scene;
};

var twoPI = 2 * Math.PI;

var Knob = function Knob(_ref) {
  var onChange = _ref.onChange,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 1 : _ref$max,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value,
      color = _ref.color,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 150 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 150 : _ref$height,
      _ref$radialSegments = _ref.radialSegments,
      radialSegments = _ref$radialSegments === void 0 ? 8 : _ref$radialSegments;
  var ref = (0, _react.useRef)();

  var _useMouseRotation = (0, _useMouseRotation2.default)(document, min, max),
      addRotationHandler = _useMouseRotation.addRotationHandler;

  var scene;
  var cone;
  (0, _react.useEffect)(function () {
    scene = createScene(ref, color, width / 8, width, height);
    cone = addCone(scene, color, width, height, radialSegments);
    cone.rotation.y += value / max % twoPI * 100;
    addRotationHandler(ref.current, handleRotation);
  }, [ref]);

  var handleRotation = function handleRotation(deltaX, deltaY) {
    cone.rotation.y += deltaX / 100;
    cone.rotation.x += deltaY / 100;
    var nornalisedRotation = cone.rotation.y % twoPI / twoPI;
    var val = min + nornalisedRotation * (max - min);
    var roundedVal = Math.abs(Math.round(val * 10) / 10);
    onChange(roundedVal);
  };

  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: width,
      height: height,
      cursor: 'grab'
    },
    ref: ref
  }), title && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      textAlign: 'center'
    }
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      borderTop: "solid 3px ".concat(colorHexToString(color)),
      borderRadius: 1,
      textAlign: 'center',
      padding: 5,
      marginTop: 5
    }
  }, value)));
};

var colorHexToString = function colorHexToString(color) {
  return "#".concat(('00000' + (color | 0).toString(16)).slice(-6));
};

var _default = Knob;
exports.default = _default;